var _defs, _g, _g2, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExercise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 380.18,
    height: 327.27,
    viewBox: "0 0 380.18 327.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b8b43;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.4,55.26h-1A13.78,13.78,0,0,0,351.64,69v80.84H265.05l1,5.16a11.71,11.71,0,0,1-1,8.86h86.59V313.49a13.78,13.78,0,0,0,13.78,13.78h1a13.78,13.78,0,0,0,13.78-13.78V69A13.78,13.78,0,0,0,366.4,55.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.83,163l-2.28-13.16h-90.4l-2.32,13.37-.06.19c-.05.16-.11.31-.16.46h95.48c-.05-.15-.11-.3-.16-.46Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.64,155l1-5.16H28.54V69A13.78,13.78,0,0,0,14.76,55.26h-1A13.78,13.78,0,0,0,0,69V313.49a13.78,13.78,0,0,0,13.78,13.78h1a13.78,13.78,0,0,0,13.78-13.78V163.9h87.12A11.67,11.67,0,0,1,114.64,155Z",
    transform: "translate(0 0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.21,28.49A26.91,26.91,0,0,1,190,54.6C174.6,54.39,163,41.66,163.49,25.69c.64-15,12.3-26.11,27.18-25.68C207,.66,217.75,12.1,217.21,28.49Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.62,55.37c-26.85,8.55-38.91,8.34-62.78.42-2.36-.84-4.85.64-4.85,2.75l-.12,69.74c0,.07,0,.15,0,.23V295a14.59,14.59,0,0,0,14.71,14.38h0A14.59,14.59,0,0,0,183.28,295V199.4h0a6.86,6.86,0,0,1,6.93-6.78h.28a6.86,6.86,0,0,1,6.93,6.78h0v95.7a14.54,14.54,0,0,0,14.71,14.32h0A14.59,14.59,0,0,0,226.84,295V58.22C226.84,56.11,223.86,54.63,221.62,55.37Z",
    transform: "translate(0 0)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.27,293.53a2,2,0,0,1-2-2v-90a2,2,0,0,1,4,0v90A2,2,0,0,1,221.27,293.53Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.82,168.4h0c-5.57,1.27-12-.26-13.78-5.91l-10.22-59a12.1,12.1,0,0,1-.54-3.28l.06-41.85c0-2.31,3.38-3.59,5-1.93l9.38,13.4a10.37,10.37,0,0,1,2,3.63l16.17,82.32C264.63,161.46,259.81,166.9,254.82,168.4Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.88,168.4h0c5.57,1.27,12.06-.26,13.79-5.91l10.21-59a12.1,12.1,0,0,0,.54-3.28l-.06-41.85c0-2.31-3.37-3.59-5-1.93l-9.38,13.4a10.37,10.37,0,0,0-2,3.63L117.8,155.82C116.07,161.46,120.89,166.9,125.88,168.4Z",
    transform: "translate(0 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExercise);
export default __webpack_public_path__ + "static/media/Icon_Exercise.26dd4d5bacfedcfae92d195ef32f0cb8.svg";
export { ForwardRef as ReactComponent };